<div *ngIf="device">
  <div class="device-title typog-h2">{{ device.title }}</div>
  <div>
    <img class="mt-3" width="100%" [src]="device.img" [alt]="device?.imgAlt" />
    <div class="mt-3">{{ device.desc }}</div>
  </div>
</div>
